import { render, staticRenderFns } from "./customer-issue.vue?vue&type=template&id=65ca91e4"
import script from "./customer-issue.vue?vue&type=script&lang=js"
export * from "./customer-issue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports